export default __webpack_public_path__ + "static/media/s365-inc-bg.8cf93cc7.jpeg";